"use strict";

exports.__esModule = true;
exports.TimePeriodController = TimePeriodController;
exports.getTimePeriod = getTimePeriod;
exports.useSelectionContext = useSelectionContext;
var _react = _interopRequireDefault(require("react"));
var _ReportingPeriodContext = require("../ReportingPeriod/ReportingPeriodContext");
var _SelectionContext = require("../../Core/SelectionContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getTimePeriod(reportingPeriod, selection, timePeriodMode) {
  var timePeriod = reportingPeriod;
  if (timePeriodMode === "SELECTION" && selection && selection.selected.reportingPeriod) {
    timePeriod = selection.selected.reportingPeriod;
  }
  return timePeriod;
}
function TimePeriodController(props) {
  var dataRange = props.dataRange,
    children = props.children;
  var reportingPeriod = _react["default"].useContext(_ReportingPeriodContext.ReportingPeriodContext);
  var selection = _react["default"].useContext(_SelectionContext.SelectionContext);
  var timePeriod = getTimePeriod(reportingPeriod, selection, dataRange);
  return children(timePeriod);
}
function useSelectionContext(props) {
  if (props === void 0) {
    props = {};
  }
  var _props = props,
    dataRange = _props.dataRange;
  var reportingPeriod = _react["default"].useContext(_ReportingPeriodContext.ReportingPeriodContext);
  var selection = _react["default"].useContext(_SelectionContext.SelectionContext);
  return getTimePeriod(reportingPeriod, selection, dataRange);
}